module.exports = __webpack_public_path__ + "assets/x-ddd23b.svg";